import { Box, TextField, Typography } from '@mui/material';

import { MemberFormData } from '../types/member.types';

import styles from './email-address-section.module.css';

import { PaperBoxStyles } from '@/components/styles';

interface EmailAddressSectionProps {
  formData: MemberFormData;
  onUpdateField: (field: keyof MemberFormData, value: MemberFormData[keyof MemberFormData]) => void;
  isFieldValid: (field: keyof MemberFormData) => boolean;
  getFieldError: (field: keyof MemberFormData) => string | undefined;
  isEditMode?: boolean;
}

export const EmailAddressSection = ({
  formData,
  onUpdateField,
  isFieldValid,
  getFieldError,
  isEditMode = false,
}: EmailAddressSectionProps) => {
  return (
    <PaperBoxStyles elevation={1} sx={{ paddingBottom: '32px' }}>
      <Typography variant='h5' fontWeight='bold' className={styles.sectionTitle}>
        メールアドレス
      </Typography>

      <Box className={styles.sectionGrid}>
        <Box className={styles.row}>
          <TextField
            required
            fullWidth
            label='メールアドレス'
            placeholder='例：User@nohara-inc.co.jp*'
            value={formData.email || ''}
            onChange={(e) => onUpdateField('email', e.target.value)}
            error={!isFieldValid('email')}
            helperText={getFieldError('email')}
            slotProps={{ input: { inputProps: { maxLength: 100 } } }}
            disabled={isEditMode}
            sx={
              isEditMode
                ? {
                    '& .MuiInputBase-root': {
                      backgroundColor: '#f5f5f5',
                      color: '#666666',
                    },
                    '& .MuiInputLabel-root': {
                      color: '#666666',
                    },
                  }
                : {}
            }
          />
        </Box>
      </Box>
    </PaperBoxStyles>
  );
};
